import { Phone } from "lucide-react";
import { useT } from "@/lib/i18n";

export function UrgencyBanner() {
  const { tk } = useT();
  const phoneNumber = "+34665649354";
  const displayNumber = "+34 665 649 354";

  return (
    <div className="bg-gold/10 border-b border-gold/30 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-gold/5 via-transparent to-gold/5 animate-pulse" />
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-center gap-3 md:gap-6 relative">
        <span className="text-gold font-semibold text-xs md:text-sm tracking-wide uppercase whitespace-nowrap">
          {tk("banner.urgency.label", "Urgencia legal")}
        </span>
        <a
          href={`tel:${phoneNumber}`}
          className="inline-flex items-center gap-1.5 bg-gold/90 hover:bg-gold text-primary-foreground text-xs md:text-sm font-bold px-3 py-1 md:px-4 md:py-1.5 rounded-full transition-colors shadow-md shadow-gold/20"
        >
          <Phone size={14} />
          {displayNumber}
        </a>
        <span className="text-foreground/80 text-xs md:text-sm font-medium tracking-wide whitespace-nowrap hidden sm:inline">
          {tk("banner.urgency.subLabel", "Abogados 24 horas")}
        </span>
      </div>
    </div>
  );
}
